// Browser polyfills
import '@babel/polyfill';
import 'whatwg-fetch';

import * as React from 'react';
import { Router, navigate, Location } from '@reach/router';
import { Layout } from '@nackle/paper';
import * as get from 'lodash/get';
import NackleMenu from '@nackle/menu';
import { setLanguageBundle } from '@nackle/intl-tools';
// components
import { AppHeader, AppFooter } from '@nackle/studio-tools';
import Versions from 'components/routes/versions';
import Privacy from 'components/routes/privacy';
import InvalidRoute from 'components/routes/invalid-route';
// auth
import auth from 'app/auth';

import { apiPostNavigationBundle } from '../routes/privacy/api';

const NotFound = ({}) => <InvalidRoute />; // eslint-disable-line
const CompanyRouter = ( { children } ) => <div>{ children }</div>;

export default class App extends React.Component {
    static defaultProps = {
        user: {
            claims: {}
        }
    };
    state = {
        cmxBundleLoaded: false
    };
    constructor( props ) {
        super( props );
        const profile = get( props, 'user.claims', {} );
        !!profile && this.props.setProfile( profile );
    }
    componentDidMount() {
        if ( window.location.pathname === '/' ) {
            navigate( '/' );
        }

        apiPostNavigationBundle().then( bundle => {
            setLanguageBundle( 'en-US', bundle.bundles[ 'en-US' ] );
            this.setState( { cmxBundleLoaded: true } );
        } );
    }

    handleCompanyChange = async company => {
        await auth.delegate( company.id );
        navigate( `/${ company.id }` );
    };

    render() {
        const { cmxBundleLoaded } = this.state;
        return (
            <Location>
                { () => {
                    const match = window.location.pathname.match(
                        /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
                    );
                    if ( !match ) {
                        return <div />;
                    }
                    const companyId = match[ 0 ];
                    return (
                        <Layout className="root-layout">
                            <AppHeader
                                companyId={ companyId }
                                onCompanyChange={ this.handleCompanyChange }
                                auth={ auth }
                            />
                            <Layout>
                                <NackleMenu
                                    auth={ auth }
                                    cmxBundleLoaded={ cmxBundleLoaded }
                                    collapsible={ true }
                                />
                                <Layout className="page-layout">
                                    <Layout.Content className="app-content">
                                        <Router>
                                            <CompanyRouter path="/:companyId">
                                                <Versions path="/" companyId={ companyId } />
                                                <Privacy path="version/:privacyId" />
                                                <NotFound default />
                                            </CompanyRouter>
                                        </Router>
                                    </Layout.Content>
                                    <AppFooter />
                                </Layout>
                            </Layout>
                        </Layout>
                    );
                } }
            </Location>
        );
    }
}
